var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 52,
    viewBox: "0 0 180 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.219 52H6.78128C3.12132 52 0.123779 49.0734 0.123779 45.5V6.5C0.123779 2.92663 3.12132 2.74817e-06 6.78128 2.74817e-06H173.219C176.879 2.74817e-06 179.876 2.92663 179.876 6.5V45.5C179.876 49.0734 176.879 52 173.219 52Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.219 1.04162C176.301 1.04162 178.809 3.4905 178.809 6.5V45.5C178.809 48.5095 176.301 50.9584 173.219 50.9584H6.78128C3.69886 50.9584 1.19064 48.5095 1.19064 45.5V6.5C1.19064 3.4905 3.69886 1.04162 6.78128 1.04162H173.219ZM173.219 2.74817e-06H6.78128C3.12132 2.74817e-06 0.123779 2.92663 0.123779 6.5V45.5C0.123779 49.0734 3.12132 52 6.78128 52H173.219C176.879 52 179.876 49.0734 179.876 45.5V6.5C179.876 2.92663 176.879 2.74817e-06 173.219 2.74817e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2601 13.3162C63.2601 14.4017 62.9272 15.2711 62.2715 15.9195C61.5175 16.6881 60.5355 17.0748 59.3322 17.0748C58.1821 17.0748 57.2001 16.6816 56.3946 15.9065C55.5873 15.12 55.1846 14.1547 55.1846 12.9993C55.1846 11.844 55.5873 10.8787 56.3946 10.0987C57.2001 9.31708 58.1821 8.92383 59.3322 8.92383C59.9047 8.92383 60.4507 9.0392 60.9716 9.2537C61.4909 9.46983 61.9136 9.76233 62.2199 10.1231L61.5242 10.8088C60.9899 10.193 60.2626 9.88908 59.3322 9.88908C58.4934 9.88908 57.766 10.1751 57.1485 10.752C56.5377 11.3305 56.2315 12.0796 56.2315 12.9993C56.2315 13.9191 56.5377 14.6747 57.1485 15.2532C57.766 15.8236 58.4934 16.1161 59.3322 16.1161C60.2226 16.1161 60.9716 15.8236 61.5625 15.2467C61.9519 14.8648 62.1733 14.3383 62.2315 13.6656H59.3322V12.7263H63.2002C63.2468 12.9295 63.2601 13.1261 63.2601 13.3162Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3968 10.0606H65.7634V12.5306H69.0389V13.4699H65.7634V15.9399H69.3968V16.897H64.7349V9.10352H69.3968V10.0606Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7274 16.897H72.6988V10.0606H70.4702V9.10352H75.9577V10.0606H73.7274V16.897Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.929 16.897V9.10352H80.9559V16.897H79.929Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5079 16.897H84.4876V10.0606H82.2507V9.10352H87.7448V10.0606H85.5079V16.897Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.134 15.8935C97.3467 16.6816 96.3714 17.0748 95.208 17.0748C94.0379 17.0748 93.0626 16.6816 92.2753 15.8935C91.4898 15.107 91.0986 14.1417 91.0986 12.9993C91.0986 11.857 91.4898 10.8917 92.2753 10.1052C93.0626 9.31708 94.0379 8.92383 95.208 8.92383C96.3647 8.92383 97.34 9.31708 98.1273 10.1117C98.9195 10.9047 99.3107 11.8635 99.3107 12.9993C99.3107 14.1417 98.9195 15.107 98.134 15.8935ZM93.036 15.2402C93.6285 15.8236 94.3492 16.1161 95.208 16.1161C96.0601 16.1161 96.7875 15.8236 97.3733 15.2402C97.9642 14.6568 98.2638 13.9077 98.2638 12.9993C98.2638 12.091 97.9642 11.3418 97.3733 10.7585C96.7875 10.1751 96.0601 9.88258 95.208 9.88258C94.3492 9.88258 93.6285 10.1751 93.036 10.7585C92.4451 11.3418 92.1455 12.091 92.1455 12.9993C92.1455 13.9077 92.4451 14.6568 93.036 15.2402Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.754 16.897V9.10352H102.002L105.883 15.1648H105.928L105.883 13.6665V9.10352H106.91V16.897H105.838L101.774 10.5368H101.729L101.774 12.0415V16.897H100.754Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8455 28.2783C87.7182 28.2783 85.1634 30.602 85.1634 33.8082C85.1634 36.9883 87.7182 39.3364 90.8455 39.3364C93.9796 39.3364 96.5344 36.9883 96.5344 33.8082C96.5344 30.602 93.9796 28.2783 90.8455 28.2783ZM90.8455 37.1589C89.1296 37.1589 87.6533 35.776 87.6533 33.8082C87.6533 31.8143 89.1296 30.4558 90.8455 30.4558C92.5615 30.4558 94.0445 31.8143 94.0445 33.8082C94.0445 35.776 92.5615 37.1589 90.8455 37.1589ZM78.4476 28.2783C75.3136 28.2783 72.7654 30.602 72.7654 33.8082C72.7654 36.9883 75.3136 39.3364 78.4476 39.3364C81.58 39.3364 84.1298 36.9883 84.1298 33.8082C84.1298 30.602 81.58 28.2783 78.4476 28.2783ZM78.4476 37.1589C76.73 37.1589 75.2487 35.776 75.2487 33.8082C75.2487 31.8143 76.73 30.4558 78.4476 30.4558C80.1636 30.4558 81.6399 31.8143 81.6399 33.8082C81.6399 35.776 80.1636 37.1589 78.4476 37.1589ZM63.6946 29.9732V32.3229H69.4417C69.2736 33.6359 68.8242 34.6012 68.1351 35.2739C67.2963 36.0864 65.9898 36.9883 63.6946 36.9883C60.1578 36.9883 57.3883 34.2014 57.3883 30.7483C57.3883 27.2952 60.1578 24.5083 63.6946 24.5083C65.607 24.5083 66.9984 25.2379 68.0253 26.1837L69.7213 24.5278C68.2849 23.1888 66.3742 22.1602 63.6946 22.1602C58.8446 22.1602 54.7686 26.013 54.7686 30.7483C54.7686 35.4835 58.8446 39.3364 63.6946 39.3364C66.316 39.3364 68.2849 38.4979 69.8328 36.9249C71.419 35.3763 71.9133 33.1988 71.9133 31.4405C71.9133 30.8945 71.8667 30.3924 71.7835 29.9732H63.6946ZM124.022 31.7948C123.554 30.5582 122.111 28.2783 119.172 28.2783C116.259 28.2783 113.834 30.5192 113.834 33.8082C113.834 36.9054 116.234 39.3364 119.451 39.3364C122.053 39.3364 123.554 37.7878 124.171 36.8859L122.241 35.6298C121.597 36.5495 120.719 37.1589 119.451 37.1589C118.191 37.1589 117.287 36.595 116.708 35.4835L124.283 32.4237L124.022 31.7948ZM116.299 33.6359C116.234 31.5039 117.995 30.4119 119.256 30.4119C120.245 30.4119 121.084 30.8945 121.364 31.5852L116.299 33.6359ZM110.142 39H112.632V22.75H110.142V39ZM106.065 29.51H105.981C105.422 28.8633 104.355 28.2783 103.004 28.2783C100.168 28.2783 97.5746 30.7093 97.5746 33.826C97.5746 36.9249 100.168 39.3364 103.004 39.3364C104.355 39.3364 105.422 38.7465 105.981 38.0803H106.065V38.8733C106.065 40.9874 104.908 42.1233 103.042 42.1233C101.521 42.1233 100.577 41.0508 100.188 40.1489L98.0223 41.0313C98.6465 42.497 100.299 44.3008 103.042 44.3008C105.961 44.3008 108.425 42.6238 108.425 38.5434V28.6147H106.065V29.51ZM103.217 37.1589C101.501 37.1589 100.065 35.7565 100.065 33.826C100.065 31.8777 101.501 30.4558 103.217 30.4558C104.908 30.4558 106.241 31.8777 106.241 33.826C106.241 35.7565 104.908 37.1589 103.217 37.1589ZM135.679 22.75H129.724V39H132.207V32.8429H135.679C138.437 32.8429 141.141 30.8945 141.141 27.7957C141.141 24.6984 138.43 22.75 135.679 22.75ZM135.744 30.5825H132.207V25.0104H135.744C137.598 25.0104 138.656 26.5135 138.656 27.7957C138.656 29.0534 137.598 30.5825 135.744 30.5825ZM151.094 28.2474C149.3 28.2474 147.434 29.0209 146.667 30.7353L148.871 31.6372C149.345 30.7353 150.217 30.4428 151.139 30.4428C152.427 30.4428 153.734 31.1984 153.754 32.5325V32.7032C153.305 32.4497 152.343 32.0743 151.159 32.0743C148.786 32.0743 146.367 33.3499 146.367 35.7305C146.367 37.908 148.311 39.3104 150.497 39.3104C152.168 39.3104 153.09 38.5743 153.669 37.7179H153.754V38.974H156.152V32.7405C156.152 29.8594 153.949 28.2474 151.094 28.2474ZM150.795 37.1524C149.982 37.1524 148.851 36.7592 148.851 35.776C148.851 34.5183 150.262 34.0357 151.484 34.0357C152.577 34.0357 153.09 34.2713 153.754 34.5817C153.559 36.0864 152.233 37.1524 150.795 37.1524ZM164.89 28.6033L162.036 35.6477H161.951L159 28.6033H156.322L160.756 38.4475L158.226 43.9254H160.821L167.653 28.6033H164.89ZM142.506 39H144.996V22.75H142.506V39Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0179 9.79947C13.6267 10.1992 13.4004 10.8216 13.4004 11.6276V40.3771C13.4004 41.1831 13.6267 41.8055 14.0179 42.2052L14.1144 42.293L30.615 26.1892V25.809L14.1144 9.70522L14.0179 9.79947Z",
    fill: "url(#paint0_linear_5464_32189)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1093 31.5605L30.6152 26.1899V25.8097L36.116 20.439L36.2392 20.5089L42.7535 24.1278C44.6126 25.1548 44.6126 26.8448 42.7535 27.8783L36.2392 31.4907L36.1093 31.5605Z",
    fill: "url(#paint1_linear_5464_32189)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2391 31.4902L30.6152 25.9994L14.0181 42.2055C14.6355 42.8392 15.6425 42.9156 16.7876 42.2819L36.2391 31.4902Z",
    fill: "url(#paint2_linear_5464_32189)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2391 20.5091L16.7876 9.71751C15.6425 9.09025 14.6355 9.16663 14.0181 9.80038L30.6152 26L36.2391 20.5091Z",
    fill: "url(#paint3_linear_5464_32189)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5464_32189",
    x1: 29.15,
    y1: 40.6765,
    x2: 7.3391,
    y2: 18.3371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5464_32189",
    x1: 45.1744,
    y1: 25.998,
    x2: 12.9562,
    y2: 25.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5464_32189",
    x1: 33.181,
    y1: 23.0144,
    x2: 3.60371,
    y2: -7.27957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5464_32189",
    x1: 9.84022,
    y1: 51.7709,
    x2: 23.0478,
    y2: 38.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.48334886.svg";
export { ForwardRef as ReactComponent };